import { Pipe, PipeTransform } from '@angular/core';
import {PROPERTY_TYPES} from '../../constants/property.constansts';

@Pipe({
  name: 'propertyType'
})
export class PropertyTypePipe implements PipeTransform {

  transform(value: string | number): string {
    const propertyTypeId = Number(value);
    if ((typeof propertyTypeId !== 'number') || isNaN(propertyTypeId)) {
      return undefined;
    }
    return PROPERTY_TYPES.filter(type => type.id === propertyTypeId).pop()?.label;
  }

}
